import React, { useState } from 'react';
import { Row, Col, FormGroup, Input, Label } from 'reactstrap';

//Components
import TextField from '../../../components/TextField/TextField';

//Helpers
import mascaras from '../../../helpers/mascaras';

export default function Residuos({ residuos, setResiduos, errors, setErrors }) {

    //onChange para os campos de residuos
    const onChangeResiduos = (e) => {
        const { name, value } = e.target;
        setResiduos({
            ...residuos,
            [name]: value
        })
    }
    const optionsFrequencia = [
        { text: "Selecione", value: "" },
        { text: "Recipiente rígido, com tampa e pedal", value: "Recipiente rígido, com tampa e pedal" },
        { text: "Contêiner de PEAD", value: "Contêiner de PEAD" },
        { text: "Saco plástico", value: "Saco plástico" },
        { text: "Saco plástico branco, com simbologia infectante", value: "Saco plástico branco, com simbologia infectante" },
        { text: "Outros", value: "Outros" },
    ]
    return (
        <div className='mb-4'>
            <Row>
                <Col md="12" lg="12">
                    <TextField mask={mascaras.floatMask} invalid={!!errors.totalResiduosMes} label={"* Quantidade total de resíduos gerados por mês (KG)"} name="totalResiduosMes" value={residuos.totalResiduosMes} onChange={onChangeResiduos} />
                </Col>
            </Row>
            <h5 className='ms-3'>Tipo de Recipiente de Acondicionamento para Resíduos</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"Grupo A"} type="select" options={optionsFrequencia} name="recipienteGrupopA" value={residuos.recipienteGrupopA} onChange={onChangeResiduos} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Grupo B"} type="select" options={optionsFrequencia} name="recipienteGrupopB" value={residuos.recipienteGrupopB} onChange={onChangeResiduos} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Grupo C"} type="select" options={optionsFrequencia} name="recipienteGrupopC" value={residuos.recipienteGrupopC} onChange={onChangeResiduos} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"Grupo D"} type="select" options={optionsFrequencia} name="recipienteGrupopD" value={residuos.recipienteGrupopD} onChange={onChangeResiduos} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Grupo E"} type="select" options={optionsFrequencia} name="recipienteGrupopE" value={residuos.recipienteGrupopE} onChange={onChangeResiduos} />
                </Col>
            </Row>
            <Row>
                <Col md={"12"} lg={"6"}>
                    <FormGroup tag="fieldset">
                        <legend className='label'>Possui área interna de acondicionamento de resíduo?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="areaInternaAcondicionamentoResiduos" onChange={onChangeResiduos} value={"false"} checked={residuos.areaInternaAcondicionamentoResiduos === "false" ? true : false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="areaInternaAcondicionamentoResiduos" onChange={onChangeResiduos} value={"true"} checked={residuos.areaInternaAcondicionamentoResiduos === "true" ? true : false} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>
                <Col md={"12"} lg={"6"}>
                    <FormGroup tag="fieldset">
                        <legend className='label'>Possui área externa de acondicionamento de resíduo?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="areaExternaAcondicionamentoResiduos" onChange={onChangeResiduos} value={"false"} checked={residuos.areaExternaAcondicionamentoResiduos=== "false" ? true : false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="areaExternaAcondicionamentoResiduos" onChange={onChangeResiduos} value={"true"} checked={residuos.areaExternaAcondicionamentoResiduos=== "true" ? true : false} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                    </FormGroup>
                </Col>
            </Row>
        </div>
    )
}